import Api from '@/services/api.js';

export default {
  addClient(details) {
    return Api.post('clients/', details);
  },
  getAllClients() {
    return Api.get('clients/');
  },
  deleteClient(client) {
    return Api.delete(`clients/${client}`);
  },
  updateClient(client) {
    var clientId = client.id;
    return Api.put(`clients/${clientId}`, client);
  },
  getClientsByContractor(contractor) {
    return Api.get('clients/byContractor/' + contractor);
  },
}